"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var socket_io_1 = require("./socket-io");
var constants_1 = require("./constants");
var add_subscriber_1 = require("./add-subscriber");
exports.attachListeners = function (webSocketInstance, url, setters, optionsRef, reconnect, reconnectCount, expectClose) {
    var setLastMessage = setters.setLastMessage, setReadyState = setters.setReadyState;
    var interval;
    var reconnectTimeout;
    if (optionsRef.current.fromSocketIO) {
        interval = socket_io_1.setUpSocketIOPing(webSocketInstance);
    }
    if (optionsRef.current.share) {
        var removeSubscriber = add_subscriber_1.addSubscriber(webSocketInstance, url, {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState,
        }, optionsRef, reconnect, reconnectCount, expectClose);
        return removeSubscriber;
    }
    webSocketInstance.onmessage = function (message) {
        optionsRef.current.onMessage && optionsRef.current.onMessage(message);
        if (typeof optionsRef.current.filter === 'function' && optionsRef.current.filter(message) !== true) {
            return;
        }
        if (expectClose.current === false) {
            setLastMessage(message);
        }
    };
    webSocketInstance.onopen = function (event) {
        optionsRef.current.onOpen && optionsRef.current.onOpen(event);
        reconnectCount.current = 0;
        if (expectClose.current === false) {
            setReadyState(function (prev) {
                var _a;
                return Object.assign({}, prev, (_a = {}, _a[url] = constants_1.ReadyState.OPEN, _a));
            });
        }
    };
    webSocketInstance.onclose = function (event) {
        var _a, _b;
        optionsRef.current.onClose && optionsRef.current.onClose(event);
        if (expectClose.current === false) {
            setReadyState(function (prev) {
                var _a;
                return Object.assign({}, prev, (_a = {}, _a[url] = constants_1.ReadyState.CLOSED, _a));
            });
        }
        if (optionsRef.current.shouldReconnect && optionsRef.current.shouldReconnect(event)) {
            var reconnectAttempts = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_RECONNECT_LIMIT;
            if (reconnectCount.current < reconnectAttempts) {
                if (expectClose.current === false) {
                    reconnectTimeout = setTimeout(function () {
                        reconnectCount.current++;
                        reconnect();
                    }, (_b = optionsRef.current.reconnectInterval) !== null && _b !== void 0 ? _b : constants_1.DEFAULT_RECONNECT_INTERVAL_MS);
                }
            }
            else {
                console.error("Max reconnect attempts of " + reconnectAttempts + " exceeded");
            }
        }
    };
    webSocketInstance.onerror = function (error) {
        var _a, _b;
        optionsRef.current.onError && optionsRef.current.onError(error);
        if (optionsRef.current.retryOnError) {
            if (reconnectCount.current < ((_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_RECONNECT_LIMIT)) {
                expectClose.current = true;
                reconnectTimeout = setTimeout(function () {
                    reconnectCount.current++;
                    reconnect();
                }, (_b = optionsRef.current.reconnectInterval) !== null && _b !== void 0 ? _b : constants_1.DEFAULT_RECONNECT_INTERVAL_MS);
            }
        }
    };
    return function () {
        setReadyState(function (prev) {
            var _a;
            return Object.assign({}, prev, (_a = {}, _a[url] = constants_1.ReadyState.CLOSING, _a));
        });
        if (reconnectTimeout)
            clearTimeout(reconnectTimeout);
        webSocketInstance.close();
        if (interval)
            clearInterval(interval);
    };
};
//# sourceMappingURL=attach-listener.js.map